import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PortfolioModel } from '../portfolio-form/portfolio.model';
import { FILE_SIZE, FILE_TYPE_JSON, Utils } from '@app/_helpers';
import { NgxToastrService } from '@app/_shared/providers';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FILE_SIZE_ERROR, INVALID_JSON_FILE, MULTIPLE_FILES_ERROR, OFFLINE_MESSAGE, UPLOAD_ERROR_MESSAGE } from '@app/_shared/strings';

@Component({
  selector: 'app-upload-portfolio',
  templateUrl: './upload-portfolio.component.html',
  styleUrls: ['./upload-portfolio.component.scss']
})
export class UploadPortfolioComponent implements OnInit {

  selectedFile: File | null = null;
  isDragOver: boolean = false;

  constructor(
    private router: Router,
    private toastr: NgxToastrService,
    private dialogRef: MatDialogRef<UploadPortfolioComponent>,
  ) { }

  ngOnInit(): void {
  }

  onDragOver(event: any) {
    Utils.preventEvent(event);
    this.isDragOver = true;
  }

  onDragLeave(event: any) {
    Utils.preventEvent(event);
    this.isDragOver = false;
  }

  onDrop(event: any) {
    Utils.preventEvent(event);
    this.isDragOver = false;
    if (event?.dataTransfer && event.dataTransfer?.files.length > 0) {
      this.isValidFile(event.dataTransfer.files[0], event.dataTransfer.files?.length) && (this.selectedFile = event.dataTransfer.files[0]);
    }
  }

  isValidFile(file: File, filesLength:number) {
    if (!file) {
      return false;
    }
    
    if(filesLength > 1){
      this.toastr.simpleCustomToaster(MULTIPLE_FILES_ERROR);
      return false;
    }

    if (file.type !== FILE_TYPE_JSON) {
      this.toastr.simpleCustomToaster(INVALID_JSON_FILE);
      return false;
    }

    if (file.size > FILE_SIZE) {
      this.toastr.simpleCustomToaster(FILE_SIZE_ERROR);
      return false;
    }

    return true;
  }

  onFileSelected(event: any) {
    this.isValidFile(event?.target?.files[0], event?.target?.files?.length) && (this.selectedFile = event.target.files[0]);
  }

  uploadPortfolio() {
    if (!navigator.onLine) {
      this.toastr.simpleCustomToaster(OFFLINE_MESSAGE);
      return;
    }

    if (!this.selectedFile) {
      return;
    }

    try {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        const text = fileReader.result;
        console.log('fileReader', text);
        const portfolio = JSON.parse(text as string);
        const portfolioModel = new PortfolioModel(portfolio);
        if (portfolio) {
          portfolioModel.portfolioName = this.selectedFile.name.split('.')[0];
          delete portfolioModel.id;
          delete portfolioModel.createdAt;
          delete portfolioModel.updatedAt;
          delete portfolioModel.subscribers
          delete portfolioModel.bookmarkers
          delete portfolioModel.creator;
          delete portfolioModel.visibilityStatus;
          portfolioModel.isPublic = false;


          if (portfolioModel.isExternalStrategy) {
            this.router.navigate(['/trading/creator-space/external-strategy/'], {
              queryParams: {
                displayOnly: false,
                uploadPortfolio: true
              },
              state: { uploadPortfolioDetails: portfolioModel }
            });
          } else {
            this.router.navigate(['/trading/strategies/create'], {
              queryParams: { uploadPortfolio: true },
              state: { uploadPortfolioDetails: portfolioModel }
            });
          }
          this.closeDialog();
        }

      }

      // Read the file as text
      fileReader.readAsText(this.selectedFile);
    } catch (error) {
      console.log(error, UPLOAD_ERROR_MESSAGE);
      this.toastr.simpleCustomToaster(UPLOAD_ERROR_MESSAGE);
    }
  }

  closeDialog() {
    this.dialogRef?.close();
  }

}
